import './App.css';
import AppRoutes from './Routes';
import ConfigProvider from './lib/configProvider';
import { Helmet } from 'react-helmet';

const umamiWebsiteId = process.env.REACT_APP_UMAMI_WEBSITE_ID;

function App() {
  return (
    <>
      {umamiWebsiteId && (
        <Helmet>
          <script
            defer
            src="https://analytics.itswhereishipeverything.space/script.js"
            data-website-id={umamiWebsiteId}
          />
        </Helmet>
      )}
      <ConfigProvider>
        <AppRoutes />
      </ConfigProvider>
    </>
  );
}
export default App;
